import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import swal from "sweetalert";

const { Text } = Typography;

function Callback() {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [xdata, setXdata] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ state สำหรับ spinner

  //   const logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=localhost:3000/login`;

  let logoutUrl = ``;
  if (xlocation === "localhost") {
    logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(
      "http://localhost:3000/login"
    )}`;
  } else {
    logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(
      "https://research.rihes.cmu.ac.th/login"
    )}`;
  }

  useEffect(
    () => {
      const code = searchParams.get("code");
      const savedUser = localStorage.getItem("user");
      const savedXdata = localStorage.getItem("xdata");

      // ✅ ถ้ามีข้อมูลใน localStorage ให้ดึงกลับมาแสดง
      if (!code && savedUser) {
        setUser(JSON.parse(savedUser));
        if (savedXdata) {
          setXdata(JSON.parse(savedXdata));
        }

        setLoading(false);
        return;
      }

      if (!code) return;

      // ป้องกันการใช้ code ซ้ำ
      if (sessionStorage.getItem("used_code") === code) {
        console.warn(
          "Authorization code already used, skipping token request."
        );

        setLoading(false);
        return;
      }

      const fetchData = async () => {
        try {
          // ✅ เริ่มโหลด
          setLoading(true);

          // แลก code เป็น access token
          const tokenRes = await axios.post(xURL + "auth/token", { code });
          //   console.log("Access Token:", tokenRes.data);
          setXdata(tokenRes.data);
          localStorage.setItem("xdata", JSON.stringify(tokenRes.data));
          localStorage.setItem("access_token", tokenRes.data.access_token);

          // เก็บว่า code นี้ถูกใช้แล้ว
          sessionStorage.setItem("used_code", code);

          // 2️⃣ เรียก CMU API ด้วย token
          const accessToken = tokenRes.data.access_token;

          const cmuApiUrl =
            "https://api.cmu.ac.th/mis/cmuaccount/prod/v3/me/basicinfo"; // ตัวอย่าง URL ของ CMU API
          const userRes = await axios.get(cmuApiUrl, {
            headers: { Authorization: `Bearer ${accessToken}` }
          });

          const user = userRes.data;
          // 09/01/2026 ปลดล็อค คณะ
          //organization_code = 27|สถาบันวิจัยวิทยาศาสตร์สุขภาพ มช.
          // 08|คณะแพทย์ศาสตร์ มช.

          // console.log("Organization Code:", user.organization_code);

          axios
            .post(xURL + "log_login", {
              cmuitaccount: user.cmuitaccount,
              name: user.firstname_TH + " " + user.lastname_TH,
              organization_code: user.organization_code
            })
            .then(result => {})
            .catch(function(error) {
              // handle error
              console.log("problem here", error);
            });

          if (
            user.organization_code !== "27" &&
            user.organization_code !== "07"
          ) {
            // alert("คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้");
            swal(
              "สิทธิ์ไม่เพียงพอ",
              "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้!",
              "warning"
            ).then(() => {
              // ล้าง token ฝั่ง client ก่อน
              localStorage.clear();

              // Redirect ออกจากระบบ CMU/MS
              window.location.href = logoutUrl;

              return;
            });

            // ล้าง token ฝั่ง client ก่อน
            localStorage.removeItem("token");
            localStorage.removeItem("user");

            // Redirect ออกจากระบบ CMU/MS
            window.location.href = logoutUrl;
            return;
          }

          // console.log("user:", userRes.data);

          setUser(userRes.data);
          localStorage.setItem("user", JSON.stringify(userRes.data));

          // ✅ ตรวจสอบข้อมูลใน Database ก่อน navigate
          const checkRes = await axios.post(xURL + "check_user", user);

          // ✅ ตรวจสอบว่ามีข้อมูลใน response หรือไม่
          if (!checkRes.data || checkRes.data.length === 0) {
            // alert("ไม่พบข้อมูลผู้ใช้งานในระบบฐานข้อมูล กรุณาติดต่อผู้ดูแลระบบ");
            // swal(
            //   "ไม่พบผู้ใช้งาน",
            //   "ไม่พบข้อมูลผู้ใช้งานในระบบฐานข้อมูล กรุณาติดต่อผู้ดูแลระบบ",
            //   "warning"
            // ).then(() => {
            //   // ✅ รอจนกด OK แล้วค่อย redirect
            //   localStorage.clear();
            //   window.location.href = logoutUrl;
            //   return;
            // });

            // axios
            //   .post(xURL + "insert_user2", { user })
            //   .then(result => {
            //     return;
            //   })
            //   .catch(function(error) {
            //     // handle error
            //     console.log("problem here", error);
            //   });

            await axios.post(xURL + "insert_user2", { user });

            // ✅ หลัง insert เสร็จ ให้ไปหน้า default
            setLoading(false);
            navigate("/Research_scopus", { replace: true });
            return;
          }

          //  ถ้าพบข้อมูลในระบบแล้ว -> ตรวจสอบสิทธิ์
          const userLevel = checkRes.data[0].user_level_id;
          setLoading(false);

          // ✅ ล้าง query ?code=... จาก URL เพื่อป้องกัน refresh ซ้ำ
          // navigate("/callback", { replace: true });
          if (userLevel == "1") {
            navigate("/Research_guest", { replace: true });
          } else if (userLevel == "7") {
            navigate("/Research_main", { replace: true });
          } else if (userLevel == "8") {
            navigate("/Research_coordinator", { replace: true });
          } else {
            navigate("/Research_scopus", { replace: true });
          }
        } catch (err) {
          console.error("❌ Error during token exchange or API call:", err);

          // ตรวจจับ error หมดอายุ หรือ invalid_grant แล้วให้ login ใหม่
          if (
            (err.response &&
              err.response.data &&
              err.response.data.error_description &&
              err.response.data.error_description.includes("AADSTS70008")) ||
            (err.response &&
              err.response.data &&
              err.response.data.error_description &&
              err.response.data.error_description.includes("invalid_grant"))
          ) {
            console.warn("Token expired or invalid. Redirecting to login...");

            if (xlocation === "localhost") {
              window.location.href = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/authorize?client_id=2a95ec4e-4317-4e7f-a4dd-e034704f316f&response_type=code&redirect_uri=http://localhost:3000/callback&scope=api://cmu/Mis.Account.Read.Me.Basicinfo offline_access`;
            } else {
              window.location.href = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/authorize?client_id=2a95ec4e-4317-4e7f-a4dd-e034704f316f&response_type=code&redirect_uri=https://research.rihes.cmu.ac.th/callback&scope=api://cmu/Mis.Account.Read.Me.Basicinfo offline_access`;
            }
          }
        }
      };

      fetchData();
    },
    [searchParams]
  );

  // ✅ UI ส่วน Loading
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 40, color: "#1677ff" }} spin />
          }
        />
        <Text type="secondary" style={{ marginTop: 16, fontSize: 16 }}>
          กำลังตรวจสอบสิทธิ์การเข้าใช้งาน...
        </Text>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", paddingTop: "100px" }}>
      <h2>
        {" "}Welcome! {user && user.firstname_TH} {user && user.lastname_TH}
      </h2>
    </div>

    /* <pre>{JSON.stringify(xdata, null, 2)}</pre>
      <br />
      <h1>Welcome!</h1>
      <p>cmuitaccount_name: {user && user.cmuitaccount_name}</p>
      <p>cmuitaccount: {user && user.cmuitaccount}</p>
      <p>organization_code: {user && user.organization_code}</p>
      <p>prename_TH: {user && user.prename_TH}</p>
      <p>firstname_TH: {user && user.firstname_TH}</p>
      <p>lastname_TH: {user && user.lastname_TH}</p>
      <p>organization_name_TH: {user && user.organization_name_TH}</p>
      <br />
      <br />
       */
    /* <button
        onClick={() => {
          localStorage.clear();
          window.location.href = logoutUrl;
        }}
      >
        Logout
      </button> */
  );
}

export default Callback;
